import CloudQueueIcon from '@material-ui/icons/CloudQueue';
import {
  createFrontendModule,
  createRouteRef,
  NavItemBlueprint,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import React from 'react';

const sandboxRouteRef = createRouteRef();

const sandboxPage = PageBlueprint.make({
  params: {
    path: '/',
    routeRef: sandboxRouteRef,
    title: 'Infrastructure Request',
    loader: () =>
      import('./SandboxPage').then(m => React.createElement(m.SandboxPage)),
  },
});

const sandboxNavItem = NavItemBlueprint.make({
  params: {
    routeRef: sandboxRouteRef,
    title: 'Infrastructure Request',
    icon: CloudQueueIcon,
  },
});

export const sandboxModule = createFrontendModule({
  pluginId: 'app',
  extensions: [sandboxPage, sandboxNavItem],
});
